// src/app/modules/Members/pages/members-table/column-formatters/MemberTypeColumnFormatter.jsx
import React from "react";

const TYPE_CONFIG = {
  unit:       { label: 'Unit',       color: '#5341C4', bg: '#F0EEFF' },
  house:      { label: 'House',      color: '#16a34a', bg: '#F0FDF4' },
  office:     { label: 'Office',     color: '#2563EB', bg: '#EFF6FF' },
  room:       { label: 'Room',       color: '#0891B2', bg: '#ECFEFF' },
  shop:       { label: 'Shop',       color: '#D97706', bg: '#FFFBEB' },
  department: { label: 'Dept',       color: '#7C3AED', bg: '#F5F3FF' },
  ward:       { label: 'Ward',       color: '#DC2626', bg: '#FEF2F2' },
  other:      { label: 'Other',      color: '#7E8299', bg: '#F4F4F8' },
  // member types
  admin:      { label: 'Admin',      color: '#DC2626', bg: '#FEF2F2' },
  manager:    { label: 'Manager',    color: '#7C3AED', bg: '#F5F3FF' },
  security:   { label: 'Security',   color: '#2563EB', bg: '#EFF6FF' },
  staff:      { label: 'Staff',      color: '#5341C4', bg: '#F0EEFF' },
  member:     { label: 'Member',     color: '#16a34a', bg: '#F0FDF4' },
};

export function MemberTypeColumnFormatter(cellContent, row) {
  const raw = (row.type || row.member_type || cellContent || 'other').toLowerCase();
  const cfg = TYPE_CONFIG[raw] || { label: raw, color: '#7E8299', bg: '#F4F4F8' };

  return (
    <span style={{
      display:        'inline-flex',
      alignItems:     'center',
      gap:            5,
      padding:        '3px 9px',
      borderRadius:   20,
      fontSize:       10,
      fontWeight:     700,
      textTransform:  'uppercase',
      letterSpacing:  '0.5px',
      background:     cfg.bg,
      color:          cfg.color,
      whiteSpace:     'nowrap',
    }}>
      <span style={{
        width:        5,
        height:       5,
        borderRadius: '50%',
        background:   cfg.color,
        flexShrink:   0,
      }} />
      {cfg.label}
    </span>
  );
}